
import React, { ReactNode } from 'react';

interface ReportSectionProps {
  title: string;
  icon?: ReactNode;
  children: ReactNode;
  className?: string;
}

const ReportSection: React.FC<ReportSectionProps> = ({ 
  title, 
  icon, 
  children, 
  className = ''
}) => {
  return (
    <section className={`mb-10 ${className}`}>
      <div className="flex items-center mb-4">
        {icon && <div className="mr-2 text-blue-dark">{icon}</div>}
        <h2 className="text-xl font-semibold">{title}</h2>
      </div>
      <div className="bg-white rounded-lg shadow-sm p-6 border border-gray-100">
        {children}
      </div>
    </section>
  );
};

export default ReportSection;
